module.exports = __webpack_public_path__ + "static/media/ljubljana-19.623eaeb2.jpg";